import React, { useEffect, useRef, useState } from "react";
import ProfileButton from "../profile-button/profile-button";
import { useNavigate } from "react-router";
import { IconBackArrow } from "../../../assets/icons/icon-back-arrow";
import Notification from "./Notification/Notification";
import { NotificationToast } from "./Notification/NotificationToast";
import EclinProSyncBadge from "../eclin-pro-sync-bradge/eclin-pro-sync-badge";
// access control
import { useHasRole } from "../../../guards/useHasRole";
import { ROLES } from "../constant/roles";

const Header = ({
  headertitle,
  isSearch,
  search,
  setSearch,
  onSearchClick,
  onCloseClick,
  showClose,
  backbutton,
  goBackToTrials,
  docuSignStatus,
  iSeclinProSync = false,
  eclinProSyncStatus,
  eclinProSyncResult,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const dropdownRef = useRef(null);
  const isAdmin = useHasRole([ROLES.ADMIN]);
  useEffect(() => {
    if (search == "") {
      onCloseClick();
    }
  }, [search]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();

  const handleBack = () => {
    goBackToTrials ? goBackToTrials() : navigate(-1); // This goes back to the previous screen
  };

  const NavigateToChat = () => {
    navigate(`/conversation-list`);
  };

  const searchaction = (e) => {
    if (setSearch) {
      setSearch(e.target.value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearchClick();
    }
  };

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <header className="sticky top-0 bg-[#FFFFFF] z-10">
      {/* <h1></h1> */}
      <div className="flex justify-between px-8 py-[18px] header_sub">
        <div className="flex items-center">
          {backbutton && (
            <>
              <IconBackArrow />
              <button
                onClick={handleBack}
                className="blue_color border-r-2  py-1 pr-[10px] mr-[10px] text-[18px] font-[500]"
                style={{ borderColor: "#C8D6E6" }}
              >
                Back
              </button>
            </>
          )}

          <div className="justify-between flex items-center gap-4">
            <h1 className="header_color text-[26px] font-medium ">
              {headertitle}
            </h1>
            {iSeclinProSync && (
              <EclinProSyncBadge
                isSynced={iSeclinProSync}
                IsNav={true}
                isSyncedStatus={eclinProSyncStatus}
                eclinProSyncResult={eclinProSyncResult}
              />
            )}
            {docuSignStatus && docuSignStatus === "recipient-completed" && (
              <>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203Z"
                    fill="#16C47F"
                  />
                  <path
                    d="M17.7552 9.78078L13.6377 14.2408C12.7912 15.1577 12.368 15.6161 11.8112 15.6161C11.2544 15.6161 10.8312 15.1577 9.98468 14.2408L8.2448 12.3562M5.38552 5.50885C7.22549 5.92516 9.0995 4.94853 9.62006 3.30203C10.5905 0.232657 15.4095 0.232657 16.3799 3.30203C16.9005 4.94853 18.7745 5.92516 20.6145 5.50885C24.0445 4.73277 26.454 8.49989 23.9944 10.7932C22.675 12.0234 22.675 13.9766 23.9944 15.2068C26.454 17.5001 24.0445 21.2672 20.6145 20.4912C18.7745 20.0748 16.9005 21.0515 16.3799 22.698C15.4095 25.7673 10.5905 25.7673 9.62006 22.698C9.0995 21.0515 7.22549 20.0748 5.38552 20.4912C1.95548 21.2672 -0.454034 17.5001 2.00558 15.2068C3.32499 13.9766 3.32499 12.0234 2.00558 10.7932C-0.454033 8.49989 1.95548 4.73277 5.38552 5.50885Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </svg>
              </>
            )}
          </div>
        </div>

        <div className="flex gap-5 items-center">
          <div className="relative">
            <input
              type="search"
              className="block px-4 py-2 text-sm title_color rounded-[100px] border table_border w-[425px] h-9"
              placeholder="Search by Name or Contact..."
              value={search}
              onChange={(e) => {
                searchaction(e);
              }}
              onKeyDown={handleKeyDown}
              required
            />

            {showClose ? (
              <button
                className="w-6 h-6 blue_bg rounded-[50%] inline-flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-2"
                onClick={() => onCloseClick()}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 1L12 12" stroke="white" strokeWidth="2" />
                  <path d="M12 1L1 12" stroke="white" strokeWidth="2" />
                </svg>
              </button>
            ) : (
              <button
                className="w-6 h-6 blue_bg rounded-[50%] inline-flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-2"
                onClick={() => onSearchClick()}
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.4202 9.71315C10.225 9.51789 9.9084 9.51788 9.71313 9.71314C9.51787 9.9084 9.51787 10.225 9.71313 10.4203L10.4202 9.71315ZM11.8464 12.5536C12.0417 12.7488 12.3582 12.7488 12.5535 12.5536C12.7488 12.3583 12.7488 12.0417 12.5535 11.8464L11.8464 12.5536ZM4.9277 3.12667C5.20044 3.08347 5.38652 2.82735 5.34333 2.55461C5.30013 2.28187 5.04401 2.09578 4.77126 2.13898L4.9277 3.12667ZM2.13897 4.77128C2.09577 5.04402 2.28185 5.30015 2.55459 5.34334C2.82733 5.38654 3.08346 5.20046 3.12665 4.92772L2.13897 4.77128ZM9.71313 10.4203L11.8464 12.5536L12.5535 11.8464L10.4202 9.71315L9.71313 10.4203ZM5.79999 10.1C3.42517 10.1 1.5 8.17481 1.5 5.79999H0.5C0.5 8.7271 2.87289 11.1 5.79999 11.1V10.1ZM10.1 5.79999C10.1 8.17481 8.17481 10.1 5.79999 10.1V11.1C8.72709 11.1 11.1 8.7271 11.1 5.79999H10.1ZM5.79999 1.5C8.17481 1.5 10.1 3.42517 10.1 5.79999H11.1C11.1 2.87289 8.72709 0.5 5.79999 0.5V1.5ZM5.79999 0.5C2.87289 0.5 0.5 2.87289 0.5 5.79999H1.5C1.5 3.42517 3.42517 1.5 5.79999 1.5V0.5ZM4.77126 2.13898C3.41627 2.35359 2.35357 3.41629 2.13897 4.77128L3.12665 4.92772C3.27349 4.00062 4.0006 3.27351 4.9277 3.12667L4.77126 2.13898Z"
                    fill="white"
                  />
                </svg>
              </button>
            )}
          </div>
          <div
            ref={dropdownRef}
            onClick={toggleDropdown}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            className={
              isHover
                ? "w-9 h-9 rounded-[50%] border-[1px] border-blue flex items-center cursor-pointer justify-center relative"
                : "w-9 h-9 blue_bg rounded-[50%] flex items-center cursor-pointer justify-center relative"
            }
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 5V19"
                stroke={isHover ? "#1B2A3D" : "white"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 12H19"
                stroke={isHover ? "#1B2A3D" : "white"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            {/* Dropdown Menu */}
            {/* Dropdown Menu */}
            {isOpen && (
              <div className="absolute z-20 top-12 right-0 bg-white shadow-lg rounded-lg p-4 w-[600]">
                <div className="flex w-full space-x-4">
                  {/* Patient */}
                  <a
                    href="/add-patient"
                    className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg min-w-[173px]"
                  >
                    <div className="w-[42px] h-[42px] bg-[#EFF8E4] rounded-full flex items-center justify-center">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="21"
                          height="21"
                          transform="translate(0.5 0.5)"
                          fill="#EFF8E4"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.375 1.59375C6.07957 1.59375 4.21875 3.45457 4.21875 5.75C4.21875 8.04543 6.07957 9.90625 8.375 9.90625C10.6704 9.90625 12.5312 8.04543 12.5312 5.75C12.5312 3.45457 10.6704 1.59375 8.375 1.59375ZM5.53125 5.75C5.53125 4.17944 6.80444 2.90625 8.375 2.90625C9.94556 2.90625 11.2188 4.17944 11.2188 5.75C11.2188 7.32056 9.94556 8.59375 8.375 8.59375C6.80444 8.59375 5.53125 7.32056 5.53125 5.75Z"
                          fill="#1A1A1B"
                        />
                        <path
                          d="M17.7812 7.5C17.7812 7.13756 17.4874 6.84375 17.125 6.84375C16.7626 6.84375 16.4688 7.13756 16.4688 7.5V9.46875H14.5C14.1376 9.46875 13.8438 9.76256 13.8438 10.125C13.8438 10.4874 14.1376 10.7812 14.5 10.7812H16.4688V12.75C16.4688 13.1124 16.7626 13.4062 17.125 13.4062C17.4874 13.4062 17.7812 13.1124 17.7812 12.75V10.7812H19.75C20.1124 10.7812 20.4062 10.4874 20.4062 10.125C20.4062 9.76256 20.1124 9.46875 19.75 9.46875H17.7812V7.5Z"
                          fill="#1A1A1B"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.75 11.2188C3.45457 11.2188 1.59375 13.0796 1.59375 15.375C1.59375 17.6704 3.45457 19.5312 5.75 19.5312H11C13.2954 19.5312 15.1562 17.6704 15.1562 15.375C15.1562 13.0796 13.2954 11.2188 11 11.2188H5.75ZM2.90625 15.375C2.90625 13.8044 4.17944 12.5312 5.75 12.5312H11C12.5706 12.5312 13.8438 13.8044 13.8438 15.375C13.8438 16.9456 12.5706 18.2188 11 18.2188H5.75C4.17944 18.2188 2.90625 16.9456 2.90625 15.375Z"
                          fill="#1A1A1B"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold">Patient</h4>
                      <p className="text-xs text-gray-500">Add new patient</p>
                    </div>
                  </a>

                  {/* Trials */}
                  <a
                    href="/create-trial"
                    className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg min-w-[173px]"
                  >
                    <div className="w-[42px] h-[42px] bg-[#FFEBEB] rounded-full flex items-center justify-center">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.6562 9.25C11.6562 8.88756 11.3624 8.59375 11 8.59375C10.6376 8.59375 10.3438 8.88756 10.3438 9.25V11.2188H8.375C8.01256 11.2188 7.71875 11.5126 7.71875 11.875C7.71875 12.2374 8.01256 12.5312 8.375 12.5312H10.3438V14.5C10.3438 14.8624 10.6376 15.1562 11 15.1562C11.3624 15.1562 11.6562 14.8624 11.6562 14.5V12.5312H13.625C13.9874 12.5312 14.2812 12.2374 14.2812 11.875C14.2812 11.5126 13.9874 11.2188 13.625 11.2188H11.6562V9.25Z"
                          fill="#1A1A1B"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.6475 1.61945C12.8974 1.59375 12.0247 1.59375 11.0097 1.59375H10.9604C9.35344 1.59374 8.09379 1.59374 7.09442 1.70201C6.07457 1.81251 5.24824 2.04203 4.54271 2.55463C4.11558 2.86496 3.73996 3.24058 3.42963 3.66771C2.91703 4.37324 2.68751 5.19957 2.57701 6.21942C2.46874 7.21879 2.46874 8.47844 2.46875 10.0854V11.9146C2.46874 13.5216 2.46874 14.7812 2.57701 15.7806C2.68751 16.8004 2.91703 17.6268 3.42963 18.3323C3.73996 18.7594 4.11558 19.135 4.54271 19.4454C5.24824 19.958 6.07457 20.1875 7.09442 20.298C8.09377 20.4063 9.35339 20.4063 10.9603 20.4062H11.0396C12.6465 20.4063 13.9062 20.4063 14.9056 20.298C15.9254 20.1875 16.7518 19.958 17.4573 19.4454C17.8844 19.135 18.26 18.7594 18.5704 18.3323C19.083 17.6268 19.3125 16.8004 19.423 15.7806C19.5313 14.7812 19.5313 13.5216 19.5312 11.9147V10.1154C19.5312 9.1003 19.5312 8.22759 19.5056 7.47753C19.4494 5.83827 19.272 4.63341 18.5704 3.66771C18.26 3.24058 17.8844 2.86496 17.4573 2.55463C16.4916 1.85301 15.2867 1.67561 13.6475 1.61945ZM5.31417 3.61647C5.75868 3.29352 6.32762 3.10527 7.23579 3.00688C8.15624 2.90715 9.34487 2.90625 11 2.90625C11.7423 2.90625 12.3928 2.90629 12.9703 2.91571C12.9742 3.33103 12.9871 3.63678 13.0307 3.91206C13.3717 6.0649 15.0601 7.75333 17.2129 8.09431C17.4882 8.13791 17.794 8.15083 18.2093 8.15465C18.2187 8.73219 18.2188 9.3827 18.2188 10.125V11.875C18.2188 13.5301 18.2178 14.7188 18.1181 15.6392C18.0197 16.5474 17.8315 17.1163 17.5085 17.5608C17.2792 17.8765 17.0015 18.1542 16.6858 18.3835C16.2413 18.7065 15.6724 18.8947 14.7642 18.9931C13.8438 19.0928 12.6551 19.0938 11 19.0938C9.34487 19.0938 8.15624 19.0928 7.23579 18.9931C6.32762 18.8947 5.75868 18.7065 5.31417 18.3835C4.99847 18.1542 4.72084 17.8765 4.49147 17.5608C4.16852 17.1163 3.98027 16.5474 3.88188 15.6392C3.78215 14.7188 3.78125 13.5301 3.78125 11.875V10.125C3.78125 8.46987 3.78215 7.28124 3.88188 6.36079C3.98027 5.45262 4.16852 4.88368 4.49147 4.43917C4.72084 4.12347 4.99847 3.84584 5.31417 3.61647ZM14.327 3.70674C14.2986 3.52734 14.2878 3.31959 14.2837 2.96526C15.474 3.04731 16.1613 3.23538 16.6858 3.61647C17.0015 3.84584 17.2792 4.12347 17.5085 4.43917C17.8896 4.9637 18.0777 5.65102 18.1597 6.84131C17.8054 6.83722 17.5977 6.82638 17.4183 6.79797C15.827 6.54594 14.5791 5.29797 14.327 3.70674Z"
                          fill="#1A1A1B"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold">Trials</h4>
                      <p className="text-xs text-gray-500">Create new trials</p>
                    </div>
                  </a>

                  {/* Recruiter */}
                  {isAdmin && <a
                    href="/add-recruiter"
                    className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg min-w-[200px]"
                  >
                    <div className="w-[42px] h-[42px] bg-[#F5EFFF] rounded-full flex items-center justify-center">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.375 1.59375C6.07957 1.59375 4.21875 3.45457 4.21875 5.75C4.21875 8.04543 6.07957 9.90625 8.375 9.90625C10.6704 9.90625 12.5312 8.04543 12.5312 5.75C12.5312 3.45457 10.6704 1.59375 8.375 1.59375ZM5.53125 5.75C5.53125 4.17944 6.80444 2.90625 8.375 2.90625C9.94556 2.90625 11.2188 4.17944 11.2188 5.75C11.2188 7.32056 9.94556 8.59375 8.375 8.59375C6.80444 8.59375 5.53125 7.32056 5.53125 5.75Z"
                          fill="#1A1A1B"
                        />
                        <path
                          d="M17.7812 7.5C17.7812 7.13756 17.4874 6.84375 17.125 6.84375C16.7626 6.84375 16.4688 7.13756 16.4688 7.5V9.46875H14.5C14.1376 9.46875 13.8438 9.76256 13.8438 10.125C13.8438 10.4874 14.1376 10.7812 14.5 10.7812H16.4688V12.75C16.4688 13.1124 16.7626 13.4062 17.125 13.4062C17.4874 13.4062 17.7812 13.1124 17.7812 12.75V10.7812H19.75C20.1124 10.7812 20.4062 10.4874 20.4062 10.125C20.4062 9.76256 20.1124 9.46875 19.75 9.46875H17.7812V7.5Z"
                          fill="#1A1A1B"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.75 11.2188C3.45457 11.2188 1.59375 13.0796 1.59375 15.375C1.59375 17.6704 3.45457 19.5312 5.75 19.5312H11C13.2954 19.5312 15.1562 17.6704 15.1562 15.375C15.1562 13.0796 13.2954 11.2188 11 11.2188H5.75ZM2.90625 15.375C2.90625 13.8044 4.17944 12.5312 5.75 12.5312H11C12.5706 12.5312 13.8438 13.8044 13.8438 15.375C13.8438 16.9456 12.5706 18.2188 11 18.2188H5.75C4.17944 18.2188 2.90625 16.9456 2.90625 15.375Z"
                          fill="#1A1A1B"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold">Recruiter</h4>
                      <p className="text-xs text-gray-500">Add new recruiter</p>
                    </div>
                  </a>}
                </div>
              </div>
            )}
          </div>
          <Notification />
          <div
            onClick={NavigateToChat}
            className="w-9 h-9 cursor-pointer rounded-[50%] flex items-center justify-center border border_color2 header_white_icons transition duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
            >
              <circle
                cx="18"
                cy="18"
                r="18"
                fill="url(#paint0_linear_4208_8571)"
                fillOpacity="0.8"
              />
              <path
                d="M17.5483 15.5756L14.0413 15.5756C13.6782 15.5756 13.3838 15.2812 13.3838 14.9181C13.3838 14.5549 13.6782 14.2605 14.0413 14.2605L17.5483 14.2605C17.9115 14.2605 18.2059 14.5549 18.2059 14.9181C18.2059 15.2812 17.9115 15.5756 17.5483 15.5756Z"
                fill="white"
              />
              <path
                d="M13.3838 18.4251C13.3838 18.0619 13.6782 17.7675 14.0413 17.7675H21.0554C21.4185 17.7675 21.7129 18.0619 21.7129 18.4251C21.7129 18.7883 21.4185 19.0827 21.0554 19.0827H14.0413C13.6782 19.0827 13.3838 18.7883 13.3838 18.4251Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.6422 9H18.4545C19.6572 9 20.6001 8.99999 21.3579 9.06191C22.1296 9.12496 22.7671 9.25547 23.3441 9.54947C24.2927 10.0328 25.0639 10.804 25.5472 11.7526C25.8412 12.3296 25.9717 12.9671 26.0348 13.7388C26.0967 14.4966 26.0967 15.4395 26.0967 16.6421V19.0592C26.0967 19.284 26.0967 19.4209 26.091 19.5402C25.9681 22.1371 23.8906 24.2146 21.2938 24.3375C21.1744 24.3432 21.0237 24.3432 20.7738 24.3432H20.7488L20.6828 24.3433C19.9225 24.3481 19.1819 24.5855 18.5603 25.0234L18.5173 25.0541L16.2283 26.6891C14.9092 27.6313 13.1759 26.2706 13.7779 24.7655C13.8588 24.5632 13.7098 24.3432 13.492 24.3432H12.9644C10.7749 24.3432 9 22.5683 9 20.3788L9 16.6422C9 15.4395 8.99999 14.4966 9.06191 13.7388C9.12496 12.9671 9.25547 12.3296 9.54947 11.7526C10.0328 10.804 10.804 10.0328 11.7526 9.54947C12.3296 9.25547 12.9671 9.12496 13.7388 9.06191C14.4966 8.99999 15.4395 9 16.6422 9ZM13.8459 10.3727C13.1556 10.4291 12.7104 10.5375 12.3497 10.7213C11.6485 11.0785 11.0785 11.6485 10.7213 12.3497C10.5375 12.7104 10.4291 13.1556 10.3727 13.8459C10.3156 14.5439 10.3151 15.4332 10.3151 16.6716V20.3788C10.3151 21.8419 11.5012 23.0281 12.9644 23.0281H13.492C14.6402 23.0281 15.4254 24.1878 14.999 25.2539C14.8847 25.5395 15.2136 25.7977 15.4639 25.6189L17.7529 23.9839L17.8028 23.9484C18.6437 23.3559 19.6457 23.0347 20.6744 23.0282L20.7488 23.0281C21.0309 23.0281 21.1476 23.0279 21.2316 23.0239C23.151 22.933 24.6865 21.3975 24.7774 19.4781C24.7814 19.3939 24.7816 19.2905 24.7816 19.0378V16.6716C24.7816 15.4332 24.781 14.5439 24.724 13.8459C24.6676 13.1556 24.5592 12.7104 24.3754 12.3497C24.0182 11.6485 23.4481 11.0785 22.747 10.7213C22.3863 10.5375 21.9411 10.4291 21.2508 10.3727C20.5528 10.3156 19.6635 10.3151 18.4251 10.3151H16.6716C15.4332 10.3151 14.5439 10.3156 13.8459 10.3727Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6367 23.8218L17.6866 23.7862C18.5609 23.1702 19.6035 22.8358 20.6729 22.8289L20.6739 22.8289L20.7483 22.8288C21.0331 22.8288 21.144 22.8286 21.2219 22.8249C23.0383 22.7389 24.4914 21.2858 24.5774 19.4694C24.5811 19.3912 24.5814 19.2937 24.5814 19.0386V16.6724C24.5814 15.4306 24.5807 14.5509 24.5245 13.863C24.4691 13.185 24.3641 12.7691 24.197 12.4413C23.859 11.7778 23.3195 11.2383 22.656 10.9002C22.3282 10.7332 21.9123 10.6282 21.2343 10.5728C20.5463 10.5166 19.6667 10.5159 18.4249 10.5159H16.6714C15.4296 10.5159 14.55 10.5166 13.862 10.5728C13.184 10.6282 12.7681 10.7332 12.4403 10.9002C11.7768 11.2383 11.2373 11.7778 10.8993 12.4413C10.7322 12.7691 10.6272 13.185 10.5718 13.863C10.5156 14.5509 10.5149 15.4306 10.5149 16.6724V20.3796C10.5149 21.7323 11.6115 22.8288 12.9642 22.8288H13.4918C14.7815 22.8288 15.6635 24.1315 15.1845 25.329C15.1444 25.4291 15.2597 25.5196 15.3475 25.457L17.6367 23.8218ZM18.463 8.80078C19.6584 8.80078 20.608 8.80077 21.374 8.86335C22.158 8.92741 22.8248 9.06129 23.4347 9.37205C24.4209 9.87456 25.2227 10.6764 25.7252 11.6626C26.036 12.2725 26.1699 12.9392 26.2339 13.7233C26.2965 14.4892 26.2965 15.4387 26.2965 16.6341V19.0658C26.2965 19.2854 26.2965 19.4264 26.2906 19.5505C26.1628 22.2504 24.0029 24.4103 21.303 24.5381C21.1789 24.544 21.0241 24.544 20.7803 24.544H20.7488L20.6839 24.544C20.6838 24.544 20.6841 24.544 20.6839 24.544C19.9647 24.5487 19.2637 24.7732 18.6757 25.1874C18.6756 25.1875 18.6759 25.1873 18.6757 25.1874L18.6333 25.2176L16.3444 26.8526C14.8627 27.9109 12.9158 26.3826 13.592 24.692C13.6204 24.6211 13.5682 24.544 13.4918 24.544H12.9642C10.6643 24.544 8.7998 22.6795 8.7998 20.3796L8.7998 16.6343C8.7998 15.4388 8.7998 14.4892 8.86238 13.7233C8.92644 12.9392 9.06032 12.2725 9.37108 11.6626C9.87358 10.6764 10.6754 9.87456 11.6616 9.37205C12.2715 9.06129 12.9383 8.92741 13.7223 8.86335C14.4883 8.80077 15.4378 8.80078 16.6333 8.80078H18.463ZM18.5171 25.0549L18.5601 25.0242C19.1817 24.5863 19.9223 24.3489 20.6826 24.344L20.7486 24.344H20.7736C21.0235 24.344 21.1742 24.344 21.2936 24.3383C23.8904 24.2154 25.9679 22.1379 26.0909 19.541C26.0965 19.4217 26.0965 19.2848 26.0965 19.0599V16.6429C26.0965 15.4403 26.0965 14.4974 26.0346 13.7396C25.9715 12.9679 25.841 12.3304 25.547 11.7534C25.0637 10.8048 24.2925 10.0336 23.3439 9.55025C22.7669 9.25625 22.1294 9.12574 21.3577 9.06269C20.5999 9.00077 19.657 9.00078 18.4543 9.00078H16.642C15.4393 9.00078 14.4964 9.00077 13.7386 9.06269C12.9669 9.12574 12.3294 9.25625 11.7524 9.55025C10.8038 10.0336 10.0326 10.8048 9.54928 11.7534C9.25527 12.3304 9.12476 12.9679 9.06171 13.7396C8.9998 14.4974 8.9998 15.4403 8.9998 16.6429V20.3796C8.9998 22.569 10.7747 24.344 12.9642 24.344H13.4918C13.7096 24.344 13.8586 24.564 13.7777 24.7663C13.1757 26.2714 14.909 27.6321 16.2281 26.6899L18.5171 25.0549ZM20.7486 23.0288C21.0307 23.0288 21.1474 23.0286 21.2314 23.0247C23.1508 22.9338 24.6863 21.3982 24.7772 19.4788C24.7812 19.3947 24.7814 19.2913 24.7814 19.0386V16.6724C24.7814 15.434 24.7808 14.5447 24.7238 13.8467C24.6674 13.1563 24.559 12.7112 24.3752 12.3505C24.018 11.6493 23.4479 11.0793 22.7468 10.722C22.3861 10.5382 21.9409 10.4299 21.2506 10.3735C20.5526 10.3164 19.6633 10.3159 18.4249 10.3159H16.6714C15.433 10.3159 14.5437 10.3164 13.8457 10.3735C13.1554 10.4299 12.7102 10.5382 12.3495 10.722C11.6483 11.0793 11.0783 11.6493 10.7211 12.3505C10.5373 12.7112 10.4289 13.1563 10.3725 13.8467C10.3154 14.5447 10.3149 15.434 10.3149 16.6724V20.3796C10.3149 21.8427 11.501 23.0288 12.9642 23.0288H13.4918C14.6401 23.0288 15.4252 24.1886 14.9988 25.2547C14.8845 25.5403 15.2134 25.7985 15.4637 25.6197L17.7527 23.9847L17.8026 23.9492C18.6435 23.3566 19.6455 23.0355 20.6742 23.0289L20.7486 23.0288ZM17.5481 15.7764L14.0411 15.7764C13.5675 15.7764 13.1836 15.3925 13.1836 14.9189C13.1836 14.4452 13.5675 14.0613 14.0411 14.0613L17.5481 14.0613C18.0218 14.0613 18.4057 14.4452 18.4057 14.9189C18.4057 15.3925 18.0218 15.7764 17.5481 15.7764ZM13.1836 18.4259C13.1836 17.9523 13.5675 17.5683 14.0411 17.5683H21.0552C21.5288 17.5683 21.9127 17.9523 21.9127 18.4259C21.9127 18.8995 21.5288 19.2834 21.0552 19.2834H14.0411C13.5675 19.2834 13.1836 18.8995 13.1836 18.4259ZM17.5481 15.5764L14.0411 15.5764C13.678 15.5764 13.3836 15.282 13.3836 14.9189C13.3836 14.5557 13.678 14.2613 14.0411 14.2613L17.5481 14.2613C17.9113 14.2613 18.2057 14.5557 18.2057 14.9189C18.2057 15.282 17.9113 15.5764 17.5481 15.5764ZM13.3836 18.4259C13.3836 18.0627 13.678 17.7683 14.0411 17.7683H21.0552C21.4183 17.7683 21.7127 18.0627 21.7127 18.4259C21.7127 18.789 21.4183 19.0834 21.0552 19.0834H14.0411C13.678 19.0834 13.3836 18.789 13.3836 18.4259Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_4208_8571"
                  x1="18"
                  y1="0"
                  x2="18"
                  y2="36"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3338BA" />
                  <stop offset="1" stop-color="#630695" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          {/* <div className="w-9 h-9 rounded-[50%] flex items-center justify-center border border_color2 header_white_icons transition duration-300">
            <svg
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.09998 0.25C4.70442 0.25 2.07724 3.22603 2.49841 6.59536L2.57776 7.23021C2.69388 8.15916 2.35455 9.08706 1.66654 9.72195C0.240863 11.0375 -0.155232 13.1315 0.691418 14.8769L0.794769 15.09C1.54088 16.6282 3.05582 17.6355 4.74702 17.7408L4.9353 18.0636C5.9481 19.7998 7.5261 20.75 9.18314 20.75C10.8402 20.75 12.4182 19.7998 13.431 18.0636L13.6222 17.7358C15.043 17.6236 16.3384 16.8514 17.1111 15.6373C18.2932 13.7799 17.9801 11.3432 16.3668 9.84496L16.3229 9.8042C16.1263 9.62158 15.9563 9.41688 15.8151 9.1959C15.592 8.8469 15.1282 8.74484 14.7792 8.96793C14.4302 9.19103 14.3281 9.6548 14.5512 10.0038C14.7602 10.3307 15.0116 10.6335 15.3022 10.9033L15.3461 10.9441C16.4289 11.9497 16.6391 13.5852 15.8456 14.832C15.2835 15.7152 14.3092 16.25 13.2623 16.25H13.1974C13.1946 16.2499 13.1917 16.2499 13.1889 16.2499C13.1827 16.2499 13.1765 16.2499 13.1703 16.25H5.19595C5.18695 16.2498 5.17793 16.2498 5.16891 16.25H5.04147C3.8079 16.25 2.68275 15.5452 2.14438 14.4353L2.04102 14.2223C1.48294 13.0718 1.74404 11.6915 2.68379 10.8243C3.72755 9.86114 4.24234 8.45345 4.06618 7.04416L3.98682 6.40931C3.67757 3.93526 5.60667 1.75 8.09998 1.75H9.80289C10.9214 1.75 11.9242 2.18763 12.6655 2.8947C12.9652 3.18058 13.44 3.16934 13.7259 2.86959C14.0117 2.56985 14.0005 2.09511 13.7008 1.80923C12.6926 0.847744 11.3235 0.25 9.80289 0.25H8.09998Z"
                fill="#1B2A3D"
              />
              <path
                d="M16.1833 6C16.1833 7.10457 15.2878 8 14.1833 8C13.0787 8 12.1833 7.10457 12.1833 6C12.1833 4.89543 13.0787 4 14.1833 4C15.2878 4 16.1833 4.89543 16.1833 6Z"
                fill="#1B2A3D"
              />
              <circle cx="14" cy="6" r="2" fill="#F95454" />
            </svg>
          </div> */}
          {/* LOGOUT BUTTON */}
          {/* <div className="w-9 h-9 rounded-[50%] flex items-center justify-center border border_color2 header_white_icons transition duration-300">
            <div className="text-sm font-medium  inline-block  bg-clip-text">
              <Logout />
            </div>
          </div> */}

          <ProfileButton firstName={"Epic"} lastName={"Product"} />
        </div>
      </div>
    </header>
  );
};

export default Header;
